import { createRender } from './types';
import { LeftNavCtaMessage } from '../../../common/components/LeftNavCtaMessage';
import { type Source } from '../../../common/types';

import { token } from '@atlaskit/tokens';

export const render = createRender(({ onDismissed, experimentCohort }) => {
	const context: {
		experimentCohort: string;
		source: Source;
	} = {
		experimentCohort,
		source: 'jira-side-nav',
	};

	return (
		<div style={{ marginBottom: token('space.150', '0.75rem') }}>
			<LeftNavCtaMessage handleOnDismissed={onDismissed} context={context} />
		</div>
	);
});

export default render;
